import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  loader: {
    position: 'absolute',
    zIndex: () => theme.zIndex.drawer + 2,
    color: theme.palette.secondary.main,
  },

  centeredX: {
    left: '50%',
    transform: 'translateX(-50%)',
  },

  centeredY: {
    top: '50%',
    transform: 'translateY(-50%)',
  },

  backdrop: {
    background: 'rgba(0,0,0,0.1)',
  },

  flex: {
    display: 'flex',
    width: '100%',
    height: '100%',
    position: 'relative',
  },

  flexCentered: {
    justifyContent: 'center',
    alignItems: 'center',
  },

}));

export default useStyles;
